import { permissionAreaKeyNameOf } from "../../helpers/permission.helpers";
import { billingMenu } from "./configurations/billing-configuration";
import { claimsMenu } from './configurations/claims-configuration';
import { dashboardMenu } from './configurations/dashboard-configuration';
import { inventoryMenu } from "./configurations/inventory-configuration";
import { marketingMenu } from "./configurations/marketing-configuration";
import { MenuMainNode } from "./configurations/nodes";
import { outreachMenu } from './configurations/outreach-configuration';
import { patientMenu } from "./configurations/patient-configuration";
import { productMenu } from "./configurations/product-configuration";
import { reportMenu } from "./configurations/report-configuration";
import { salesMenu } from "./configurations/sales-configuration";
import { schedulingMenu } from "./configurations/scheduling-configuration";
import { workQueueMenu } from "./configurations/work-queue-configuration";

export class MenuConfiguration {
    static getNodes(): MenuMainNode[] {
        const conf: MenuMainNode[] = [
            dashboardMenu,
            workQueueMenu,
            schedulingMenu,
            patientMenu,
            salesMenu,
            claimsMenu,            
            billingMenu,
            productMenu,
            inventoryMenu,
            marketingMenu,
            outreachMenu,
            reportMenu,
            {
                icon: 'adminIconTemplate',
                title: 'Menu.Admin.Name',
                link: '/admin',
                rootPath: '/admin',
                areaPermissionKey: permissionAreaKeyNameOf("admin")
            }
        ];

        return JSON.parse(JSON.stringify(conf));
    }
}

